import HiddenIcon from 'assets/icons/eye-hidden-icon.svg';
import ShowIcon from 'assets/icons/eye-show-icon.svg';
import {
  DESKTOP_MIN_WIDTH,
  LOGIN_PASSWORD_NAME,
  LOGIN_UNAUTHORIZED_INFORM,
} from 'constants';
import { Fade } from 'helpers/animation';
import useLang from 'hooks/useLang';
import { useState } from 'react';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';

const FormInputValidation = ({
  field,
  information,
  setInformation,
  validation,
  setValidation,
  error,
  setError,
}) => {
  const { t } = useLang();

  const [isShowPassword, setShowPassword] = useState(false);

  const isPasswordField = (name) => name === LOGIN_PASSWORD_NAME;

  const isFieldInvalid =
    (error && error !== Object.keys(LOGIN_UNAUTHORIZED_INFORM)[1]) ||
    validation[field.name];

  const handleOnChange = (e) => {
    const { value, name } = e.target;
    const valueTrim = value.trim();

    const newInformation = {
      ...information,
      [name]: valueTrim,
    };
    setInformation(newInformation);

    setError('');
  };

  const handleOnFocus = (e) => {
    const { name } = e.target;

    const newValidation = {
      ...validation,
      [name]: '',
    };
    setValidation(newValidation);
  };

  const handleToggle = () => {
    setShowPassword(!isShowPassword);
  };

  const handleFormLabelOnClick = (name) => {
    const inputEle = document.getElementsByName(name)[0];

    if (inputEle) {
      inputEle.focus();
    }
  };

  return (
    <FormGroupStyled>
      <FormLabel onClick={() => handleFormLabelOnClick(field.name)}>
        {t(field.label)}
        <span>*</span>
      </FormLabel>
      <FormControl
        className={isFieldInvalid ? 'is-field-invalid' : ''}
        type={
          isPasswordField(field.name) && isShowPassword ? 'text' : field.type
        }
        name={field.name}
        placeholder={t(field.placeholder)}
        isInvalid={validation[field.name]}
        onChange={handleOnChange}
        onFocus={handleOnFocus}
        inputMode={field?.inputMode || 'false'}
      />
      {isPasswordField(field.name) && (
        <ShowHideIcon
          src={isShowPassword ? ShowIcon : HiddenIcon}
          width={24}
          height={24}
          alt=""
          onClick={handleToggle}
        />
      )}
      <FormControlFeedback hidden={false} type="invalid">
        {t(validation[field.name])}
      </FormControlFeedback>
    </FormGroupStyled>
  );
};

const FormGroupStyled = styled(Form.Group)`
  margin-bottom: 16px;
  position: relative;
  ${Fade};

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    margin-bottom: 34px;
  }
`;
const FormLabel = styled(Form.Label)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;

  color: var(--ds-c-grey-dark);

  span {
    color: var(--c-required);
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
  }
`;
const FormControl = styled(Form.Control)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;

  color: var(--ds-c-grey-dark);
  height: 44px;
  border: 1px solid var(--ds-c-grey-light);
  border-radius: 12px;
  padding-inline: 10px;
  background: var(--ds-c-white);

  &:focus {
    border: 1px solid var(--ds-c-grey-dark);
    outline: none;
    box-shadow: none;
  }

  &:invalid,
  &:invalid:focus,
  &.is-invalid {
    border: 1px solid var(--ds-c-red) !important;
    outline: none;
    box-shadow: none !important;
    background-image: none;
  }

  &.is-field-invalid {
    border: 1px solid var(--ds-c-red);
    outline: none;
    box-shadow: none;
    background-image: none;
  }

  &::placeholder {
    font-family: var(--ff-primary);
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;

    color: var(--ds-c-blue-disabled) !important;

    @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
      font-size: 16px;
      line-height: 20px;
    }
  }
`;
const FormControlFeedback = styled(Form.Control.Feedback)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;

  color: var(--ds-c-red);
  position: absolute;
  margin-top: 8px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 14px;
    line-height: 17px;
  }
`;

const ShowHideIcon = styled.img`
  position: absolute;
  right: 8px;
  top: 40px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  background-color: transparent;
`;

export default FormInputValidation;
